import type { PaymentErrorHandler } from "@offstreetparking/portal-flow/components/CreatePermitWizard/components/PaymentForm";
import { offstreetClient } from "~/services/offstreetApi";
import type { RouterOutputs } from "~/services/offstreetApi/types";

type PaymentPlatform = "AuthorizeNet" | "Spreedly" | "Elavon" | "Stripe";

type CompletionHandlers = {
	platform: PaymentPlatform;
	onSuccess: (publicIdentifier: string) => void;
	onError: PaymentErrorHandler;
};

export const resolvePaymentCompletion = ({
	result,
	platform,
	onSuccess,
	onError,
}: CompletionHandlers & { result: RouterOutputs["paymentSession"]["completePaymentSession"] }) => {
	if (result.status === "succeeded") {
		onSuccess(result.publicIdentifier);
	} else if (result.status === "failed") {
		onError({
			error:
				platform === "AuthorizeNet"
					? { type: "declined", authorizeNet: { code: result.declineCode, message: result.reason } }
					: { type: "declined" },
		});
	} else {
		onError({ error: { type: "unconfirmed" }, needsNewSession: true });
	}
};

export const useCompletePayment = ({ platform, onSuccess, onError }: CompletionHandlers) =>
	offstreetClient.paymentSession.completePaymentSession.useMutation({
		onSuccess: (result) => resolvePaymentCompletion({ result, platform, onSuccess, onError }),
		onError: () => onError({ error: { type: "unconfirmed" }, needsNewSession: true }),
	});
